// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"356c1b45","498":"0de9390e","703":"6e25d4e0"}[chunkId] + ".chunk.js";
};